import {Controller} from "stimulus";

export default class extends Controller {
  static targets = ["categories", "quote", "serviceQuote", "userInfo"];


  initialize() {
    if (this.data.get('url')) {
      this.loadCall(this.data.get('url'));
    }
  }

  get fetch_headers() {
    return {
      'Accept': 'application/json, text/html',
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest'
    };
  }

  fetchStep(event) {
    var token = document.head.querySelector("[name=csrf-token]").content;
    let url = event.currentTarget.dataset.url;
    if (event.currentTarget.dataset.address) {
      url += '?address=' + event.currentTarget.dataset.address;
    }
    fetch(url, {
      method: 'GET',
      headers: this.fetch_headers
    }).then(response => response.text())
      .then(html => {
        this.quoteTarget.innerHTML = html;
        this.quoteTarget.style.display = 'block';
        this.userInfoTarget.style.display = 'none';
        this.categoriesTarget.style.display = 'none';
      });
  }

  beginReservation(event) {
    event.preventDefault();
    let body = JSON.stringify({authenticity_token: document.head.querySelector("[name=csrf-token]").content});
    fetch(event.currentTarget.dataset.url, {
      method: 'POST',
      headers: this.fetch_headers,
      body:body
    }).then(response => response.json())
      .then(json => {
        window.location.href = json.url;
      });
  }

  endQuote() {
    this.quoteTarget.style.display = 'none';
    this.categoriesTarget.style.display = 'block';
    this.userInfoTarget.style.display = 'block';
    this.quoteTarget.innerHTML = '';
  }

  destroyQuote(event) {
    event.preventDefault();
    if (!confirm('Really delete this quote?')) {
      return true;
    }
    let target = event.currentTarget;
    let body = JSON.stringify({authenticity_token: document.head.querySelector("[name=csrf-token]").content});
    fetch(target.dataset.url, {
      method: 'DELETE',
      headers: this.fetch_headers,
      body: body
    }).then(response => response.text())
      .then(html => {
        target.closest('div.service-category').outerHTML = html;
      });
  }
}